import 'gsap/ScrollToPlugin'
import UI from './utils/UI'

UI({
  component: '.js-scrollLink'
}, ({ component }) => {
  if (!component) return
  component.addEventListener('click', evt => {
    evt.preventDefault()
    const href = component.getAttribute('href')
    // const el = document.getElementById(href)
    // const scrollTop = el.offsetTop - 50
    // TweenLite.to(window, 1, { scrollTo: { y: href, offsetY: 50 }, ease: Power1.easeInOut })
    // cons gsap = ScrollToPlugin
    // gsap.to(window, 1, { duration: 2, scrollTo: { y: href, offsetY: 50 }, ease: Power1.easeInOut })

    scrollTo(document.body, href.offsetTop, 600)
  })
})
function scrollTo(element, to, duration) {
  if (duration <= 0) return
  var difference = to - element.scrollTop
  var perTick = difference / duration * 10

  setTimeout(function() {
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}
